var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.order)?_c('div',[_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('div',{staticClass:"overline"},[_vm._v(" 検索キーワード ")]),_c('h4',[_vm._v(" "+_vm._s(_vm.order.keyword || '-')+"  ")]),_c('v-divider')],1)],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }